"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ETH_ADDRESS_ZERO = void 0;
exports.isEthAddress = isEthAddress;
const addressRegex = /^0x[a-fA-F0-9]{40}$/;
function isEthAddress(value) {
  return addressRegex.test(value);
}
const ETH_ADDRESS_ZERO = exports.ETH_ADDRESS_ZERO = "0x0000000000000000000000000000000000000000";
//# sourceMappingURL=util.js.map